const NAMES = [
  "TESCO",
  "SAINSBURY'S",
  "ASDA",
  "MORRISONS",
  "WAITROSE",
  "M&S FOOD",
  "CO-OP",
  "ALDI UK",
  "LIDL GB",
  "COMPASS GROUP",
];

export default function Marquee() {
  return (
    <section
      data-testid="editorial-marquee"
      className="overflow-hidden border-y border-line bg-white py-7"
    >
      <p className="mb-5 text-center font-mono text-[10px] uppercase tracking-[0.34em] text-zinc-400">
        Networks our principals have served
      </p>
      <div className="flex w-max animate-marquee hover:[animation-play-state:paused]">
        {[0, 1].map((copy) => (
          <div key={copy} className="flex items-center" aria-hidden={copy === 1}>
            {NAMES.map((name) => (
              <span key={`${copy}-${name}`} className="flex items-center">
                <span className="whitespace-nowrap px-10 font-mono text-xs tracking-[0.3em] text-zinc-400">
                  {name}
                </span>
                <span className="h-1.5 w-1.5 rotate-45 bg-gold/70" aria-hidden />
              </span>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
}
